export const GRADES = ["Medical Laboratory Assistant (MLA)", "Medical Laboratory Technician", "Medical Laboratory Scientist", "Specialist"];
export const GRADE_RENAMES = { "Lab Assistant": GRADES[0], "Lab Technical Officer": GRADES[1] };
export const FACILITY_TYPES = ["Private", "MOH", "GHS", "CHAG", "Teaching Hospital", "MELPWU National Secretariat", "Academia/Research"];
const DIRECTORY_TYPES = {
  "Ghana Health Service": "GHS", "Christian Health Association of Ghana": "CHAG", "Teaching Hospitals": "Teaching Hospital",
  "Private": "Private", "Health Headquarters": "MOH", "Training Institutions": "Academia/Research",
};
export const mapFacilityType = (type) => (FACILITY_TYPES.includes(type) ? type : DIRECTORY_TYPES[type] || "");
export const MAX_CHILDREN = 10;
export const EMPTY_CHILD = { full_name: "", sex: "", date_of_birth: "" };
export const legacyChildren = (d) => {
  if (Array.isArray(d.children)) return { children: d.children, no_children: d.no_children || "" };
  const names = (d.biological_children_names || "").trim();
  if (/^none$/i.test(names) || (!names && String(d.number_of_children) === "0")) return { children: [], no_children: "yes" };
  const list = names.split(/[,;\n]+/).map((n) => n.trim()).filter(Boolean).slice(0, MAX_CHILDREN);
  return { children: list.map((full_name) => ({ ...EMPTY_CHILD, full_name })), no_children: "" };
};
export const RANKS = {
  [GRADES[0]]: ["Entry", "Principal", "Superintendent"],
  [GRADES[1]]: ["Entry", "Senior", "Principal", "Deputy Chief", "Chief"],
  [GRADES[2]]: ["Entry", "Senior", "Principal", "Deputy Chief", "Chief"],
  Specialist: ["Specialist", "Senior Specialist", "Consultant"],
};
export const formatGhanaCard = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);
  return digits ? `GHA-${digits.slice(0, 9)}${digits.length > 9 ? `-${digits[9]}` : ""}` : "";
};

export const INTERN_FIELDS = ["title", "first_name", "middle_name", "last_name", "date_of_birth", "sex", "contact_number", "alternate_contact_number", "email", "ghana_card_number", "facility_name", "facility_type", "town", "district", "region_name"];
export function profileErrors(form, photo) {
  const errors = {};
  const required = {
    first_name: "First name", last_name: "Last name", date_of_birth: "Date of birth", sex: "Sex",
    contact_number: "Contact number", email: "Email", facility_name: "Facility", facility_type: "Type of Facility",
    professional_grade: "Professional Grade", rank: "Cadre", ghana_card_number: "Ghana Card number",
    emergency_contact_name: "Emergency contact name", emergency_contact_phone: "Emergency contact phone",
    emergency_contact_address: "Emergency contact address", marital_status: "Marital status",
    mother_name: "Mother's name", mother_status: "Mother's status", father_name: "Father's name", father_status: "Father's status",
    worked_at_previous_facility: "Previous employment (Yes/No)", pays_dues: "Dues Payment",
  };
  if (form.member_type === "intern") {
    Object.keys(required).forEach((key) => { if (!INTERN_FIELDS.includes(key) || key === "facility_type") delete required[key]; });
  }
  if (["intern", "private"].includes(form.member_type)) Object.assign(required, { region_name: "Region", district: "District" });
  if (!photo) errors.profile_picture = "A profile picture is required";
  if (form.marital_status === "Married") required.spouse_name = "Spouse's name";
  if (form.worked_at_previous_facility === "yes") Object.assign(required, {
    previous_facility_name: "Previous facility name", previous_facility_location: "Previous facility location", previous_facility_type: "Previous facility type",
  });
  if (form.pays_dues === "yes") Object.assign(required, { dues_mode: "Dues payment mode", tshirt_size: "T-Shirt size" });
  Object.entries(required).forEach(([key, label]) => {
    if (!String(form[key] ?? "").trim()) errors[key] = `${label} is required`;
  });
  if (form.ghana_card_number && !/^GHA-\d{9}-\d$/.test(form.ghana_card_number)) errors.ghana_card_number = "Ghana Card must contain 10 digits: GHA-XXXXXXXXX-X";
  if (form.rank && !(RANKS[form.professional_grade] || []).includes(form.rank)) errors.rank = "Select a Cadre that matches your Professional Grade";
  ["email", "emergency_contact_email"].forEach((key) => {
    if (form[key] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form[key].trim())) errors[key] = `Enter a valid ${key === "email" ? "email address" : "emergency contact email"}`;
  });
  ["contact_number", "alternate_contact_number", "emergency_contact_phone"].forEach((key) => {
    const phone = (form[key] || "").trim();
    if (phone && (!/^\+?[0-9 ()-]+$/.test(phone) || phone.replace(/\D/g, "").length < 7 || phone.replace(/\D/g, "").length > 15)) {
      errors[key] = `${key.replaceAll("_", " ")}: enter a single valid phone number`;
    }
  });
  if (form.member_type !== "intern") {
    const kids = form.children || [];
    if (!kids.length && form.no_children !== "yes") errors.children = "Add each biological child, or tick 'I have no biological children'";
    const today = new Date().toISOString().slice(0, 10);
    kids.forEach((c, i) => {
      if (!c.full_name.trim() || !c.sex || !c.date_of_birth) errors[`child_${i}`] = `Child ${i + 1}: full name, sex and date of birth are required`;
      else if (Number.isNaN(Date.parse(c.date_of_birth)) || c.date_of_birth > today) errors[`child_${i}`] = `Child ${i + 1}: enter a valid date of birth that is not in the future`;
    });
  }
  if (form.date_of_birth && (Number.isNaN(Date.parse(form.date_of_birth)) || form.date_of_birth > new Date().toISOString().slice(0, 10))) errors.date_of_birth = "Enter a valid date of birth that is not in the future";
  return errors;
}
